import { formatDate, formatDateTime } from '@/utils/format';
import type { WorkOrderDetailViewModel } from '../types/workOrderDetail.types';

interface DetailSummaryInfoProps {
  data: WorkOrderDetailViewModel;
}

export function DetailSummaryInfo({ data }: DetailSummaryInfoProps) {
  const items = [
    { label: 'Mã lệnh', value: data.code },
    { label: 'Dự án', value: data.projectName },
    { label: 'Khu vực', value: data.zoneName },
    { label: 'Giai đoạn', value: data.phaseName },
    { label: 'Loại CV', value: data.workTypeLabel },
    { label: 'Ưu tiên', value: data.priorityLabel },
    { label: 'Hạn hoàn thành', value: formatDate(data.dueDate) },
    { label: 'Cập nhật', value: formatDateTime(data.updatedAt) },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-8">
      {items.map((item) => (
        <InfoItem key={item.label} label={item.label} value={item.value} />
      ))}
    </div>
  );
}

function InfoItem({ label, value }: { label: string; value: string }) {
  const isCode = label === 'Mã lệnh';
  return (
    <div className="space-y-1 flex flex-col items-start">
      <p className="sm:text-sm text-xs text-slate-500">{label}</p>
      {isCode ? (
        <p className="break-words sm:text-sm text-xs leading-tight p-3 text-blue-600 font-semibold">{value || '---'}</p>
      ) : (
        <p className="break-words sm:text-sm text-xs leading-tight text-slate-800">{value || '---'}</p>
      )}
    </div>
  );
}
